<div class="tt-c-review tt-u-spacing--sm">
  <div class="tt-u-clip-hide" v-html="$msg('ratingStars.rating', [review.rating])"></div>
  <div class="tt-c-review__date">{{ review.dateCreatedFormatted }}</div>
  <div v-if="review.title" class="tt-c-review__heading" role="heading" :aria-level="headingLevel"><div class="tt-c-review__heading-text" v-html="review.title"></div></div>
  <div class="tt-c-review__text-content" v-html="review.text"></div>
  <div v-if="review.user" class="tt-o-byline__item tt-o-byline__author">{{formatUserName(review.user)}}</div>
</div>
